<template>
<!-- eslint-disable vue/valid-v-slot -->
  <v-container fluid align-start
    :class="{'back-image-dark': $vuetify.theme.dark, 'back-image-light': !$vuetify.theme.dark }">

    <v-layout wrap>
      <v-col cols=12 md=6 >
        <span class="title primary--text text--lighten-1 mx-6">{{$t('Today')}}</span>
        <barGraph class="light-back"
          v-bind:chartData="todayChartData">
        </barGraph>
      </v-col>
      <v-col cols=12 md=6 >
        <span class="title primary--text text--lighten-1 mx-6">{{$t('Yesterday')}}</span>
        <barGraph class="light-back"
          v-bind:chartData="yesterdayChartData">
        </barGraph>
      </v-col>
    </v-layout>

    <v-layout wrap>
      <v-col cols=12 md=6>
        <v-data-table
          :headers="matNeedHeader"
          :items="todaysMaterial"
          item-key="code"
          disable-pagination
          hide-default-footer
          :no-data-text="this.$i18n.t('No Data Available')"
        >
        <template v-slot:top>
          <v-toolbar flat dense color="secondary darken-1 primary--text">
            {{$t('Materials Needed Today')}}
          </v-toolbar>
        </template>
        <template v-slot:item.qty="{ item }">
          <span class="pe-3">{{item.qty | kgString}}</span>
        </template>
        <template v-slot:item.code="{ item }">
          <span class="ps-3">{{item.code}}</span>
        </template>

        </v-data-table>
      </v-col>
      <v-col cols=12 md=6>
        <v-data-table
          :headers="matNeedHeader"
          :items="weeksMaterial"
          item-key="code"
          disable-pagination
          hide-default-footer
          :no-data-text="this.$i18n.t('No Data Available')"
        >
          <template v-slot:top>
            <v-toolbar flat dense color="secondary darken-1 primary--text"  >
              {{$t('Materials Needed Next 7 days')}}
            </v-toolbar>
          </template>

          <template v-slot:item.qty="{ item }">
            <span class="pe-3">{{item.qty | kgString}}</span>
          </template>
          <template v-slot:item.code="{ item }">
            <span class="ps-3">{{item.code}}</span>
          </template>

        </v-data-table>
      </v-col>
    </v-layout>
  </v-container>
</template>

<script>
import barGraph from "../components/BarGraph";

export default {
  name: "Dashboard",
  components: {
    barGraph
  },
  data() {
    return {
      dummyLabel: ["", "", ""],
      dummyData: [0, 0, 0]
    }
  },
  computed: {
    matNeedHeader() {
      return [
        { text: this.$t('Feed Code'), width: "30%", align: "left", value: "code"},
        { text: this.$t('Feed Name'), width: "40%", align: "left", value: "name"},
        { text: this.$t('Qty'), width: "30%", align: "right", value: "qty"}
      ]
    },
    todayChartData: function() {
      return this.$store.getters.getTodayGraph;
    },

    yesterdayChartData: function() {
      return this.$store.getters.getYesterdayGraph;
    },
    todaysMaterial: function() {
      return this.$store.getters.getMaterialsPlan(new Date(), 1)
    },
    weeksMaterial: function() {
      return this.$store.getters.getMaterialsPlan(new Date(), 7)
    },
  },
}
</script>

<style>
.back-image-dark {
  background-image: url("../assets/cows.png");
  background-size: cover;
  background-color: black;
  background-blend-mode: lighten;
  height: 100%;
}
.back-image-light {
  background-image: url("../assets/cows.png");
  background-size: cover;
  background-color: whitesmoke;
  background-blend-mode: darken;
  height: 100%;
}
.light-back {
  background-color: transparent;
}
</style>